import {
  AlphaCard,
  VerticalStack,
  HorizontalGrid,
  Page,
  Box,
  SkeletonDisplayText,
  SkeletonBodyText,
  Bleed,
  Divider,
  HorizontalStack,
  Button,
  Avatar,
  Text,
  Link,
  Modal,
  ChoiceList,
  Checkbox,
  Spinner,
  EmptyState,
  CalloutCard,
  TextField,
  Banner
} from "@shopify/polaris";

import { EditMinor, CancelMajor, ReplayMinor, UndoMajor } from '@shopify/polaris-icons';

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { undoAcceptOffer, markAsRead, setContentUrls, saveDeploymentLink } from '../../firebase';

// This example is for guidance purposes. Copying it will come with caveats.
export default function CampaignDetails({ deals, setDeals, loading }) {

  const dealID = useParams().id;

  const deal = deals.find((deal) => deal.id === dealID);

  const [modalOpenName, setModalOpenName] = useState(null);
  const [blockFutureOffers, setBlockFutureOffers] = useState(false);
  const [silent, setSilent] = useState(false);

  const [actionLoading, setActionLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const [contentUrl, setContentUrl] = useState('');
  const [deploymentUrl, setDeploymentUrl] = useState('');

  const [versionIndex, setVersionIndex] = useState(0);
  const [trackingLinkConfirmation, setTrackingLinkConfirmation] = useState(false);

  useEffect(() => {
    if (window.location.search.includes('submit_review')) {
      setModalOpenName('addContent');
    }
  }, [])

  useEffect(() => {
    if (deal?.contentUrls) {
      setVersionIndex(deal.contentUrls.length - 1);
    }
    if (deal?.isUnread && deal.actionRequiredBy === 'influencer') {
      markAsRead(deal.id);
    }
  }, [deal]);

  async function accept() {
    try {
      setActionLoading(true)
      setAccepted(true);

      const newDeals = [...deals];
      newDeals.find((deal) => deal.id === dealID).status = 'accepted';
      setDeals(newDeals);

    } catch (error) {
      console.error(error)
    } finally {
      setActionLoading(false)
    }
  }

  async function undo() {
    try {
      setActionLoading(true)
      await undoAcceptOffer(deal.id);
      setAccepted(false);

      const newDeals = [...deals];
      newDeals.find((deal) => deal.id === dealID).status = 'offerSent';
      setDeals(newDeals);

    } catch (error) {
      console.error(error)
    } finally {
      setActionLoading(false)
    }
  }

  async function decline() {
    try {
      setActionLoading(true)
      // await rejectOffer(deal.id, { silent, blockFutureOffers, shop: deal.shop });

      const newDeals = [...deals];
      newDeals.find((deal) => deal.id === dealID).status = 'rejected';
      setDeals(newDeals);

    } catch (error) {
      console.error(error)
    } finally {
      setActionLoading(false)
    }
  }

  function getWeight(status) {
    if (deal.status === status) {
      return 'bold';
    }
    return 'normal';
  }

  if (loading) {
    return (
      <Page
        breadcrumbs={[{ content: "Products", url: "/deals" }]}
        title={<HorizontalStack><Spinner /><SkeletonDisplayText size="large" /></HorizontalStack>}
      >
        <HorizontalGrid columns={{ xs: 1, md: "2fr 1fr" }} gap="4">
          <VerticalStack gap="4">
            <AlphaCard roundedAbove="sm">
              <VerticalStack gap="4">
                <Text fontWeight="bold">Stage</Text>
                <SkeletonBodyText lines={1} />
              </VerticalStack>
            </AlphaCard>
            <AlphaCard roundedAbove="sm">
              <VerticalStack gap="6">
                <Text fontWeight="bold">Details</Text>
                <SkeletonBodyText lines={4} />
              </VerticalStack>
            </AlphaCard>
            <AlphaCard roundedAbove="sm">
              <VerticalStack gap="4">
                <Text fontWeight="bold">Messages</Text>
                <SkeletonBodyText lines={3} />
              </VerticalStack>
            </AlphaCard>
          </VerticalStack>
          <VerticalStack gap={{ xs: "4", md: "2" }}>
            <AlphaCard roundedAbove="sm">
              <VerticalStack gap="5">
                <Avatar size="large" shape="square" />
                <SkeletonBodyText lines={1} />
                <Button fullWidth disabled>View Website</Button>
              </VerticalStack>
            </AlphaCard>
          </VerticalStack>
        </HorizontalGrid>
      </Page>
    )
  }

  if (!deal) {
    return (
      <Page
        breadcrumbs={[{ content: "Products", url: "/deals" }]}
        title={'Deal'}
      >
        <AlphaCard>
          <EmptyState
            heading="404"
            action={{ content: 'Go back', url: '/deals' }}
          >
            <p>Deal not found</p>
          </EmptyState>
        </AlphaCard>
      </Page>
    );
  }

  let content = {};
  if (deal.status === 'rejected' || deal.status === 'withdrawn') {
    content.timeline = (
      <>
        <Text>Stage</Text>
        <HorizontalStack gap="5">
          <Box>
            <Text>
              Offer Received
            </Text>
          </Box>
          <Box>
            <Text fontWeight={"bold"}>
              {deal.status}
            </Text>
          </Box>
        </HorizontalStack>
      </>
    )
  } else {
    content.timeline = (
      <>
        <Text>Stage</Text>
        <HorizontalStack gap="5">
          <Box>
            <Text fontWeight={getWeight('offerSent')}>
              Offer Received
            </Text>
          </Box>
          <Box>
            <Text fontWeight={getWeight('accepted')}>
              Offer Accepted
            </Text>
          </Box>
          {
            deal.status === 'paid' ? (
              <Box>
                <Text fontWeight={getWeight('paid')}>
                  Paid
                </Text>
              </Box>
            ) : (
              <Box>
                <Text fontWeight={getWeight('review')}>
                  Review
                </Text>
              </Box>
            )
          }
          <Box>
            <Text fontWeight={getWeight('approved')}>
              Approved
            </Text>
          </Box>
          <Box>
            <Text fontWeight={getWeight('published')}>
              Published
            </Text>
          </Box>
        </HorizontalStack>
      </>
    )
  }
  content.messageWindow = (
    <>
      <h2>Messages</h2>
      <HorizontalGrid columns={{ xs: 1, md: 2 }}>
      </HorizontalGrid>
    </>
  )
  content.profilePanel = (
    <>
      <VerticalStack gap="4">
        <Avatar customer size="large" shape="square" name={deal.brandName} source={deal.storeAvatar} />
        <Text>{deal.shopName}</Text>
        <Button url={'https://' + deal.shopDomain} target="_blank" fullWidth>View Website</Button>
        <Box border="divider" borderRadius="base" minHeight="2rem" />
      </VerticalStack>
    </>
  );

  async function updateContentUrls(remove = false) {
    setActionLoading(true)
    try {
      if (remove) {
        await setContentUrls(deal.id, deal.contentUrls.filter((_, i) => i !== versionIndex));
      } else {
        await setContentUrls(deal.id, [...(deal.contentUrls || []), contentUrl])
      }
      const activeDealIndex = deals.findIndex(d => d.id === deal.id)
      let updatedDeals = [...deals]
      if (remove) {
        updatedDeals[activeDealIndex] = { ...deal, contentUrls: deal.contentUrls.filter((_, i) => i !== versionIndex) }
      } else {
        if (deal.contentUrls && deal.contentUrls.length > 0) {
          updatedDeals[activeDealIndex] = { ...deal, contentUrls: [...deal.contentUrls, contentUrl] }
        } else {
          updatedDeals[activeDealIndex] = { ...deal, contentUrls: [contentUrl] }
        }
      }
      setDeals(updatedDeals)
      setModalOpenName(null)
      setContentUrl('')
    } catch (e) {
      console.error(e)
    } finally {
      setActionLoading(false)
    }
  }

  console.log('deals', deals);

  if (modalOpenName === 'accept' && deal.status === 'accepted') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Offer Accepted!"
          secondaryActions={[
            {
              content: "Close",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <Text fontWeight="bold">The next step is to wait for payment.</Text>
            <Text>You can reverse your acceptance until {deal.shopName} submits payment.</Text>
          </Modal.Section>
        </Modal >
      </>
    )
  } else if (modalOpenName === 'accept') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Accept Offer"
          primaryAction={{
            content: "Accept",
            onAction: accept,
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <Text fontWeight="bold">Are you sure you want to accept this offer?</Text>
            <Text>This binds you to the specifications & price set by {deal.shopName}.</Text>
          </Modal.Section>
        </Modal >
      </>
    )
  } else if (modalOpenName === 'undoAccept') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Undo Accept?"
          primaryAction={{
            content: "Undo",
            onAction: undo,
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <Text fontWeight="bold">Are you sure you want to undo accepting?</Text>
            <Text>This will return the offer to the previous stage. To decline it, select decline instead.</Text>
          </Modal.Section>
        </Modal >
      </>
    )
  } else if (modalOpenName === 'decline') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Really Decline?"
          primaryAction={{
            content: "Decline",
            onAction: decline,
            destructive: true,
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <VerticalStack gap="4">
              <Text>Even if you're not open to working with this store right now, it's recommended to send a counter offer, or a message</Text>
              <HorizontalStack gap="4">
                <Checkbox label="Silent Decline" checked={silent} onChange={setSilent} />
                <Checkbox label="Also block future offers from this store" checked={blockFutureOffers} onChange={setBlockFutureOffers} />
              </HorizontalStack>
            </VerticalStack>
          </Modal.Section>
        </Modal >
      </>
    )
  } else if (modalOpenName === 'addContent') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Add a Content Link for Review"
          primaryAction={{
            content: "Add",
            onAction: async () => {
              updateContentUrls()
            },
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <VerticalStack gap="4">
              <Text>Upload your content to any hosting service, or as a shareable draft. (For example, an unlisted youtube video)</Text>
              <Text>The brand will be notified and then can give you feedback, until it meets the specifications</Text>
              <TextField prefix="https://" label="Content URL" value={contentUrl} onChange={setContentUrl} />
              <Text>Once approved, simply publish and you will get paid!</Text>
            </VerticalStack>
          </Modal.Section>
        </Modal >
      </>
    )
  } else if (modalOpenName === 'removeVersion') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title={`Really Remove Version #${versionIndex + 1}?`}
          primaryAction={{
            content: "Remove",
            onAction: async () => {
              updateContentUrls(true);
            },
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <p>This version, only, will be removed</p>
            <p>This cannot be undone</p>
          </Modal.Section>
        </Modal >
      </>

    );
  } else if (modalOpenName === 'addDeployment') {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Add a Published Content Link to Get Paid!"
          primaryAction={{
            content: "Add",
            onAction: async () => {
              setActionLoading(true);
              await saveDeploymentLink(deal.id, deploymentUrl);
              setActionLoading(false);
              setModalOpenName(null);
              const newDeals = [...deals];
              newDeals.find((deal) => deal.id === dealID).status = 'published';
              setDeals(newDeals);
            },
            loading: actionLoading,
            disabled: !trackingLinkConfirmation
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
            <VerticalStack gap="4">
              <Text>Content published? Copy and paste the direct link here, to finally get paid!</Text>
              <TextField prefix="https://" label="Published Content URL" value={deploymentUrl} onChange={setDeploymentUrl} />
              <HorizontalStack blockAlign="center">
                <Checkbox checked={trackingLinkConfirmation} onChange={setTrackingLinkConfirmation} />
                <Text>I have also included the <b>custom tracking link </b>in my post</Text>
              </HorizontalStack>
            </VerticalStack>
          </Modal.Section>
        </Modal >
      </>
    )
  } else {
    content.acceptModal = (
      <>
        <Modal
          open={!!modalOpenName}
          onClose={() => setModalOpenName(null)}
          title="Really Decline?"
          primaryAction={{
            content: "Decline",
            onAction: accept,
            destructive: true,
            loading: actionLoading,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setModalOpenName(null),
            }
          ]}
        >
          <Modal.Section>
          </Modal.Section>
        </Modal >
      </>
    )
  }

  console.log('versionindex', versionIndex, deal.contentUrls)

  if (deal.status === 'review') {
    content.todoPanel = (
      <CalloutCard
        title={"Wait for Review, Or Update Your Content"}
        illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
        primaryAction={{
          content: "Update Content",
          onAction: () => setModalOpenName('addContent'),
        }}
        onDismiss={() => setModalOpenName('removeVersion')}
      >
        <Page
          title={`Version #${versionIndex + 1}`}
          pagination={{
            hasNext: versionIndex < deal.contentUrls.length - 1,
            hasPrevious: versionIndex > 0,
            onPrevious: () => {
              setVersionIndex(versionIndex - 1);
            },
            onNext: () => {
              setVersionIndex(versionIndex + 1);
            }
          }}
        >
          <Link url={'https://' + deal.contentUrls[versionIndex]} external={true}>{deal.contentUrls[versionIndex]}</Link>
        </Page>
      </CalloutCard>
    )
  } else if (deal.status === 'approved') {
    content.todoPanel = (
      <>
        <CalloutCard
          title="It's time to Publish."
          illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
          primaryAction={{
            content: 'Add Published Link',
            onAction: () => setModalOpenName('addDeployment'),
          }}
        >
          <p>Your content was approved. First, make sure you add this tracking link.</p>
          <Banner
            title="Custom tracking link:"
            status="info"
            onDismiss={() => { }}
          >
            <Link url={'https://' + deal.landingPageURL + '?p=' + deal.trackingParam} external={true}>https://{deal.landingPageURL}?={deal.trackingParam}</Link>
          </Banner>
          <p>Finally, use this button to add the direct link to your content.</p>
        </CalloutCard>
      </>
    );
  } else if (deal.status === 'published') {
    content.todoPanel = (
      <CalloutCard
        title="Published!"
        illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
        primaryAction={{
          content: 'View Content',
          url: 'https://' + deal.deploymentLink,
        }}
      >
        <p>You're all done. No action required.</p>
      </CalloutCard>
    );
  }

  let primaryAction;
  if (deal.status === 'offerSent') {
    primaryAction = {
      content: "Accept Offer",
      icon: EditMinor,
      onAction: () => setModalOpenName('accept'),
    }
  } else if (deal.status === 'accepted') {
    primaryAction = {
      content: "Undo Accept",
      icon: CancelMajor,
      primary: false,
      onAction: () => setModalOpenName('undoAccept'),
    }
  } else if (deal.status === 'paid' || deal.status === 'review') {
    primaryAction = {
      content: "Add Content",
      primary: true,
      onAction: () => setModalOpenName('addContent'),
    }
  }

  let secondaryActions;
  if (deal.status === 'paid' || deal.status === 'review' || deal.status === 'approved' || deal.status === 'complete') {
    secondaryActions = [];
  } else if (deal.status !== 'rejected' && deal.status !== 'withdrawn') {
    secondaryActions = [
      {
        content: "Decline Offer",
        icon: CancelMajor,
        onAction: () => setModalOpenName('decline'),
      }
    ]
  } else {
    secondaryActions = [
      {
        content: "Unblock Brand",
        icon: UndoMajor,
        onAction: () => setModalOpenName('decline'),
      }
    ]
  }


  return (
    <Page
      backAction={{ content: "Products", url: "/deals" }}
      title={'Deal with ' + deal.shopName}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
    >
      {content.acceptModal}
      <HorizontalGrid columns={{ xs: 1, md: "2fr 1fr" }} gap="4">
        <VerticalStack gap="4">
          <AlphaCard roundedAbove="sm">
            <VerticalStack gap="4">
              {content.timeline}
            </VerticalStack>
          </AlphaCard>
          {
            content.todoPanel
          }
          <AlphaCard roundedAbove="sm">
            <VerticalStack gap="4">
              <Text fontWeight="bold">Details</Text>
              <HorizontalGrid columns={{ xs: 1, md: 2 }}>
                <Box>
                  <Text fontWeight="bold">Deal Value</Text>
                  <Text>${deal.currentValue?.toLocaleString()}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold">Landing Page</Text>
                  <Link url={'https://' + deal.landingPageURL}>{deal.landingPageURL}</Link>
                </Box>
              </HorizontalGrid>
              <Box>
                <Text fontWeight="bold">Offer Details</Text>
                <Text>{deal.offerDescription}</Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Specifications</Text>
                <Text>{deal.specs}</Text>
              </Box>
            </VerticalStack>
          </AlphaCard>
          <AlphaCard roundedAbove="sm">
            <VerticalStack gap="4">
              {content.messageWindow}
            </VerticalStack>
          </AlphaCard>
        </VerticalStack>
        <VerticalStack gap={{ xs: "4", md: "2" }}>
          <AlphaCard roundedAbove="sm">
            {content.profilePanel}
          </AlphaCard>
          {
            /*
          <AlphaCard roundedAbove="sm">
            <VerticalStack gap="4">
              <SkeletonLabel />
              <Box border="divider" borderRadius="base" minHeight="2rem" />
              <SkeletonLabel maxWidth="4rem" />
              <Box border="divider" borderRadius="base" minHeight="2rem" />
              <SkeletonLabel />
              <SkeletonBodyText />
            </VerticalStack>
          </AlphaCard>
             */
          }
        </VerticalStack>
      </HorizontalGrid>
    </Page>
  )
}
